import { render } from "./claimantPrint.vue?vue&type=template&id=56974945&scoped=true"
import script from "./claimantPrint.vue?vue&type=script&lang=js"
export * from "./claimantPrint.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./claimantPrint.vue?vue&type=style&index=1&id=56974945&lang=scss"
import "./claimantPrint.vue?vue&type=style&index=2&id=56974945&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56974945"]])

export default __exports__